module.exports = __webpack_public_path__ + "img/photo_2023-04-27 22.07.47.eb7f2f7f.jpeg";